import dataProvider from '@/api'

export default {
  /**
   * @description Отправка данных для привязки к реферальной программе
   *
   * @tutorial
   *
   * @param {object} payload
   * @param {number} payload.name_slug - required
   *
   * @returns {object}
   */
  getInviteData (payload = {}) {
    return dataProvider.get('/new-client-landing/by-promocode-name-slug', payload, true, '1')
  },
  /**
   * @description Начислить бонус рефералу
   *
   * @tutorial
   *
   * @param {object} payload
   * @param {number} payload.name_slug - required
   *
   * @returns {object}
   */
  chargeBonus (payload = {}) {
    return dataProvider.get('/referral/charge-bonus', payload, true, '1')
  },
}
